import SecureLS from "secure-ls";

class LocalStorage {
    constructor(
        encryptionSecret,
        storageName,
        encodingType = 'aes',
        isCompression = true
    ) {
        this._storage = new SecureLS({
            encodingType: encodingType ? encodingType : 'aes',
            isCompression: isCompression ? isCompression : true,
            encryptionSecret: encryptionSecret
        });

        this._storageName = storageName;

        try {
            const storedState = this._storage.get(this._storageName);
            this._state = typeof storedState === 'object' ? storedState : {};
        } catch (error) {
            //If not parseable, state will be erased
            this._state = {}
        }
    }

    storeState() {
        this._storage.set(this._storageName, this._state);
    }

    set(key, value, expire_seconds = 0) {
        let now = Date.now();

        this._state[key] = this._state[key] = {
            value: value,
            created: now,
            expires: expire_seconds > 0 ? now + (expire_seconds * 1000) : null
        };
        this.storeState();
    }

    get(key) {
        let value = null;

        let item = this._state[key];
        if (item !== undefined) {
            //Item without expiration
            if (item.expires === null)
                value = item.value;
            else {
                let now = Date.now();
                if (now < item.expires)
                    //Not expired, return
                    value = item.value;
                else {
                    //Erase expired item
                    delete this._state[key];
                    this.storeState();
                }
            }
        }
        return value;
    }
}

export default new LocalStorage(
    process.env.VUE_APP_TOKEN_STORAGE_SECRET,
    process.env.VUE_APP_TOKEN_STORAGE_NAME,
    process.env.VUE_APP_TOKEN_STORAGE_ENCODING_TYPE,
    process.env.VUE_APP_TOKEN_STORAGE_COMPRESSED === 'true'
);